import { render, staticRenderFns } from "./VideoDetailView.vue?vue&type=template&id=d58aad88"
import script from "./VideoDetailView.vue?vue&type=script&lang=js"
export * from "./VideoDetailView.vue?vue&type=script&lang=js"
import style0 from "./VideoDetailView.vue?vue&type=style&index=0&id=d58aad88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports